
























































import { Component, Vue, Prop } from "vue-property-decorator";
import VToolbar from "@/ui/common/components/VToolbar.vue";
import VIconEdit from "../../../components/icons/VIconEdit.vue";
import VIconPrint from "../../../components/icons/VIconPrint.vue";
import { client } from "../../../api/request";
import InvoiceManagementApi from "@/api/accounting/invoice-management-api";
import VSearchBar from "../../../components/VSearchBar.vue";
import InvoiceStatus from "../components/InvoiceStatus.vue";
import InvoiceManagementService from "../../../usecases/accounting/invoice-management-service";
import BillingRuleApi from "../../../accounting/api/billing-rule-api";
import InvoiveSearchBar from "@/ui/common/components/InvoiceSearchBar.vue";
import InvoiceSearchOptions from "@/ui/common/presenters/invoice-search-options";
import SelectOption from "@/common/ui/presenters/select-option";
import { getAllProjects } from "../../../api/project-api";
import { getAllCompanies } from "@/api/company-api";
import InvoiceManagement from "@/usecases/accounting/invoice-management";

// const printApi = new PrintApi(client);
const invoiceManagementApi = new InvoiceManagementApi(client);
const invoiceService = new InvoiceManagementService(
  invoiceManagementApi,
  new BillingRuleApi(client)
);

@Component({
  components: {
    InvoiceStatus,
    VToolbar,
    VSearchBar,
    VIconEdit,
    VIconPrint,
    InvoiveSearchBar
  }
})
export default class InvoiceManagementListPage extends Vue {
  @Prop() projectId?: string;
  @Prop({ type: Boolean }) editon!: boolean;
  items: InvoiceManagement[] = [];
  query = "";
  printStatus: boolean[] = [];
  projects: SelectOption[] = [];
  companies: SelectOption[] = [];
  startDate = "";
  endDate = "";

  statusOptions = [
    {
      text: "全て(ステータス)",
      value: ""
    },
    {
      text: "未請求",
      value: "created"
    },
    {
      text: "請求済み",
      value: "requested"
    },
    {
      text: "入金済み",
      value: "paid"
    }
  ];

  edit(id: number) {
    this.$router.push({
      name: "invoice-edit",
      params: {
        id: String(id)
      }
    });
  }

  searchOptions: InvoiceSearchOptions = {};

  search() {
    this.initProjectList();
    this.loadInvoicePrintList();
    this.initCompanyList();
  }

  async changeStatus(id: string, status: string) {
    await invoiceService.changeStatus(id, status);
    await this.loadInvoicePrintList();
  }

  protected created() {
    this.initProjectList();
    this.initCompanyList();
    this.loadInvoicePrintList(this.searchOptions);
  }

  get projectOptions() {
    return [
      {
        text: "全て(現場)",
        value: ""
      },
      ...this.projects.map(s => ({
        text: s.text,
        value: String(s.value)
      }))
    ];
  }

  private async initProjectList() {
    this.projects = (await getAllProjects()).map(p => ({
      text: p.name,
      value: String(p.projectId)
    }));
  }

  get companyOptions() {
    return [
      {
        text: "全て(元請け)",
        value: ""
      },
      ...this.companies.map(s => ({
        text: s.text,
        value: String(s.value)
      }))
    ];
  }

  private async initCompanyList() {
    this.companies = (await getAllCompanies()).map(p => ({
      text: p.name,
      value: String(p.companyId)
    }));
  }

  private async loadInvoicePrintList(options: InvoiceSearchOptions = {}) {
    const new_options = {
      ...options,
      projectId: this.searchOptions.project,
      companyId: this.searchOptions.company,
      status: this.searchOptions.status,
      startDate: this.searchOptions.startDate,
      endDate: this.searchOptions.endDate
    };
    this.items = await invoiceManagementApi.findAll(new_options);
    for (var i = 0; i < this.items.length; i++) {
      this.printStatus.push(false);
    }
  }
}
